var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","ondragstart":"return false"}},[_c('router-view'),_c('video-mask'),_c('gallery-mask')],1)}
var staticRenderFns = []

export { render, staticRenderFns }